module.exports = __webpack_public_path__ + "static/media/opal.e6875291.png";